<template>
<div>
    
</div>
</template>

<script>
export default {
    name: 'VueTitle',
    props: {
        title: String
    },
    watch: {
        title(newTitle) {
            document.title = newTitle
        }
    }
}
</script>

<style>

</style>